import { Visitor, VisitorGroup } from 'graphql/generated/graphqlTypes';
import { installersGroupsVar } from 'state/vars';

export const setInstallersGroupsAction = (groups: VisitorGroup[]) => {
  installersGroupsVar(groups);
};

export const setInstallersMemberAction = (installer: Visitor, visitorGroupExternalRefs: string[]) => {
  const currentGroups = installersGroupsVar();
  const updatedGroups = currentGroups.map((group) => {
    if (group.externalRef === visitorGroupExternalRefs[0])
      if (group.members.some((member) => member.email === installer.email))
        return {
          ...group,
          members: group.members.map((member) => (member.email === installer.email ? installer : member))
        };
      else
        return {
          ...group,
          members: [...group.members, installer]
        };
    return {
      ...group,
      members: group.members.filter((member) => member.email !== installer.email)
    };
  });
  installersGroupsVar(updatedGroups);
};

export const unsetInstallerByIdAction = (visitorId: string) => {
  const currentGroups = installersGroupsVar();

  const groupWithDeletedMember = currentGroups.find((group) => group.members.some((member) => member.id === visitorId));

  const updatedGroups = currentGroups.map((group) => {
    if (group.id === groupWithDeletedMember?.id)
      return {
        ...group,
        members: group.members.filter((member) => member.id !== visitorId)
      };
    return group;
  });

  installersGroupsVar(updatedGroups);
};
